import * as capacity from '@/api/capacity'

// 获取公司概述 简介的banner图
export function fetchBanner() {

	const param = {
		client: 0
	}

	return new Promise(function(resolve, reject){
		capacity.getBanner(param)
			.then(function(result) {

				let responseBody = new Object()
				responseBody.imgUrl = result.data

				resolve(responseBody)
			})
	})
}

// 获取研发与制造 研发能力
export function fetchDevelopment() {

	const param = {
		type: 4,
		language: 'zh'
	}

	return new Promise(function(resolve, reject){
		capacity.getAbout(param)
			.then(function(result) {

				let responseBody = new Object()
				responseBody.content = result.data.content

				resolve(responseBody)
			})
	})
}

// 获取研发与制造 制造能力
export function fetchProduce() {

	const param = {
		type: 5,
		language: 'zh'
	}

	return new Promise(function(resolve, reject){
		capacity.getAbout(param)
			.then(function(result) {

				let responseBody = new Object()
				responseBody.content = result.data.content

				resolve(responseBody)
			})
	})
}